import { render, staticRenderFns } from "./ApproveTransferWarrantyStock.vue?vue&type=template&id=4513cc7d"
import script from "./ApproveTransferWarrantyStock.vue?vue&type=script&lang=js"
export * from "./ApproveTransferWarrantyStock.vue?vue&type=script&lang=js"
import style0 from "./ApproveTransferWarrantyStock.vue?vue&type=style&index=0&id=4513cc7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports